import React from 'react';
import escapeRegExp from 'lodash/escapeRegExp';

// 문자열을 입력받아서 <b>text</b> 와 같은 패턴을 리액트 <b/> 컴포넌트로 감싼 텍스트로 치환,
// newline 문자를 리액트 <br/> 컴포넌트로 치환하여 배열로 반환해주는 함수입니다.
// italic과 underline 등은 지원하지 않습니다.
// ex) 'abc<b>def</b>\nghi' => ['abc', <b>def</b>, <br/>, 'ghi']
// 아래와 같이도 사용 가능합니다.
// makeRich('<custom>1234</custom>', { custom: <div class="highlight" /> });
// => <div class="highlight">1234</div>
export function makeRich(text: string, map: { [key: string]: React.ReactElement<any> } = {}) {
  if (!map.hasOwnProperty('b')) {
    map['b'] = <b />;
  }

  const result: (string | React.ReactElement<any>)[] = [];
  const keys = Object.keys(map)
        .map(escapeRegExp)
        .join('|');
  const pattern: RegExp = new RegExp(`<(${keys})>(.*?)</(?:${keys})>|\r?\n`, 'gi');
  pattern.lastIndex = 0;
  let lastIndex: number = 0;
  let match: ReturnType<typeof pattern.exec>;
  while ((match = pattern.exec(text))) {
    const matchText = match[0];
    const matchStartIndex = pattern.lastIndex - matchText.length;
    if (lastIndex < matchStartIndex) {
      result.push(text.substring(lastIndex, matchStartIndex));
    }
    if (matchText[0] === '\n' || matchText[0] === '\r') {
      result.push(<br />);
    } else {
      const element: React.ReactElement<any> = map[match[1]];
      result.push(React.cloneElement(element, undefined, match[2]));
    }
    lastIndex = pattern.lastIndex;
  }
  if (lastIndex < text.length) {
    result.push(text.substring(lastIndex, text.length));
  }
  return React.createElement(React.Fragment, null, ...result);
}
